// extracted by mini-css-extract-plugin
module.exports = {"label":"_3oP8Qa5-CydYyB1J42ZoJI","active":"_1SM6DIJ42l2cLxeRhEhK8F"};